import sgData from './sg';
import viData from './vi';
import cnData from './cn';
import krData from './kr';
import jpData from './jp';
import azData from './az';
import idData from './id';
import hkData from './hk';
import myData from './my';
import thData from './th';
import twqData from './twq';
import arabia_enData from './arabia_en';
import arabiaData from './arabia';
import ruData from './ru';
import filData from './fil';

// left-hand side should be locale-data
const locale = {
  "en" : sgData,
  "zh" : cnData,
  "ko" : krData,
  "sg" : sgData,
  "ja" : jpData,
  "vi" : viData,
  "az" : azData,
  "id" : idData,
  "hk" : hkData,
  "my" : myData,
  "th" : thData,
  "twq": twqData,
  "en": arabia_enData,
  "ar": arabiaData,
  "ru": ruData,
  "fil": filData
}
export default locale;